import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { updatePort, portInfo } from 'actions/subs';
import { getPortResponse, getSubmitStatus, getPortInfo } from 'reducers';
import subPage from 'decorators/subPage';

import PortForm from 'components/PortForm';
import UpdatePort from './UpdatePort';

export const mapPortInfoToValues = ({ mdn, carrier, port_details }) => ({
  mdn,
  carrier,
  port_details,
});

const mapStateToProps = (state, { subId }) => ({
  portResponse: getPortResponse(state, subId),
  saveStatus: getSubmitStatus(state, 'port'),
  initialValues:
    getPortInfo(state, subId) && mapPortInfoToValues(getPortInfo(state, subId)),
  port: getPortInfo(state, subId),
  heading: 'Update Sprint Port',
  PortForm,
});

const mapDispatchToProps = {
  updatePort,
  portInfo,
  initialize,
};

export default subPage(
  connect(mapStateToProps, mapDispatchToProps)(UpdatePort),
);
